export var DataCatalogSubjectType;
(function (DataCatalogSubjectType) {
    DataCatalogSubjectType["DATA_CATALOG_SUBJECT_TYPE_USER"] = "USER";
    DataCatalogSubjectType["DATA_CATALOG_SUBJECT_TYPE_GROUP"] = "GROUP";
})(DataCatalogSubjectType || (DataCatalogSubjectType = {}));
